import React from 'react';
import { VideoBackdrop } from './VideoBackdrop';
import { TransHtml, useLocale } from '../i18n/LocaleContext';
import { BAND_IMG, BAND_VIDEO } from '../data/pexels';

/**
 * Full-bleed cinematic parallax-video band with oversized statement type —
 * replaces the phone-mockup strip. Pure lifestyle footage, violet neon.
 */
export const CinematicBand = (): React.JSX.Element => {
  const { t } = useLocale();
  return (
    <section className="cband">
      <VideoBackdrop
        className="cband-bg"
        src={BAND_VIDEO}
        poster={BAND_IMG}
        zoomOnScroll
      />
      <div className="cband-scrim" />
      <div className="wrap cband-inner">
        <span className="eyebrow eyebrow--neon">{t('band.eyebrow')}</span>
        <TransHtml tag="h2" tKey="band.h" className="cband-title" />
        <p className="cband-sub">{t('band.sub')}</p>
      </div>
    </section>
  );
};
